import React from 'react';
import ServiceTemplate from '../../components/ServicePage/ServiceTemplate';

const ISO27001: React.FC = () => {
  const sections = [
    {
      title: 'ISO 27001 Information Security Management',
      content: 'ISO 27001 is the international standard for information security management systems (ISMS). Our expert consultants guide organizations through the entire certification process, from initial gap analysis to successful audit completion, ensuring robust information security governance and continuous improvement.',
      benefits: [
        'Comprehensive ISMS implementation and management',
        'Risk assessment and treatment planning',
        'Security controls selection and implementation',
        'Documentation and policy development',
        'Internal audit and management review processes'
      ]
    },
    {
      title: 'Certification Process',
      content: 'Our structured approach to ISO 27001 certification ensures compliance with all requirements while building a sustainable information security management system.',
      benefits: [
        'Initial gap analysis and readiness assessment',
        'ISMS design and implementation',
        'Risk management framework development',
        'Security awareness and training programs',
        'Pre-certification audit and remediation support'
      ]
    },
    {
      title: 'Ongoing Maintenance',
      content: 'Maintaining ISO 27001 certification requires continuous improvement and regular monitoring. We provide ongoing support to ensure your ISMS remains effective and compliant.',
      benefits: [
        'Annual surveillance audit preparation',
        'Risk assessment reviews and updates',
        'Incident management and response procedures',
        'Management review meeting facilitation',
        'Continuous improvement program management'
      ]
    }
  ];

  const sidebarInfo = [
    {
      title: 'Certification Timeline',
      content: 'ISO 27001 certification typically takes 6-12 months depending on organization size and complexity.'
    },
    {
      title: 'Annex A Controls',
      content: 'We help implement all 114 security controls across 14 categories as defined in ISO 27001 Annex A.'
    },
    {
      title: 'Business Benefits',
      content: 'ISO 27001 certification demonstrates commitment to information security and can provide competitive advantages.'
    }
  ];

  return (
    <ServiceTemplate
      title="ISO 27001 Certification"
      subtitle="Expert guidance for implementing and maintaining ISO 27001 Information Security Management Systems to protect your organization's information assets."
      sections={sections}
      ctaTitle="Start Your ISO 27001 Journey"
      ctaDescription="Build a robust information security management system and achieve ISO 27001 certification with our expert guidance."
      sidebarInfo={sidebarInfo}
    />
  );
};

export default ISO27001;

